import axios from 'axios'
import API from './index'
import DateService from '../manager/DateService.js'

export default {
  get() {
    const url = API.BASE_URL + 'Events'
    console.log("apiUrl: ", url)
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },

  getEvent(eventId) {
    const url = API.BASE_URL + 'Events/' + eventId
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },
  getEventDocuments(eventId){
    const url = API.BASE_URL + 'Events/GetEventDocuments/' + eventId
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },
  create(evt) {
    const url = API.BASE_URL + 'Events'
    return axios
      .post(url, {
        eventId: evt.eventId,
        course: evt.course,
        description: evt.description,
        entryFee: evt.entryFee,
        eventEnd: evt.eventEnd,
        eventStart: evt.eventStart,
        signUpEnd: evt.signUpEnd,
        signUpStart: evt.signUpStart,
        start: evt.start,
        title: evt.title,
      })
      .then(response => {
        return response
      })
  },

  update(evt) {
    const url = API.BASE_URL + 'Events/' + evt.eventId
    return axios
      .put(url, {
        eventId: evt.eventId,
        course: evt.course,
        description: evt.description,
        entryFee: evt.entryFee,
        eventEnd: evt.eventEnd,
        eventStart: evt.eventStart,
        signUpEnd: evt.signUpEnd,
        signUpStart: evt.signUpStart,
        start: evt.start,
        title: evt.title,
      })
      .then(response => {
        return response
      })
  },

  delete(id) {
    const url = API.BASE_URL + 'Events/' + id
    return axios
      .delete(url, {})
      .then(response => {
        return response
      })
  },

  canSignup(startDate, endDate) {
    var start = new Date(startDate)
    var end = new Date(endDate)
    var today = new Date()

    var can = today > start && today <= end
    return can
  },

  getSignupMessage(startDate, endDate) {
    var start = new Date(startDate)
    var end = new Date(endDate)
    var today = new Date()
    let message = ''
    if (start <= today && today <= end) {
      message = 'Go to https://unknowngolf.com to signup'
    } else if (today > end) {
      message =
        'Signup is closed'
    } else if (today < start) {
      message = 'Signup will start ' + DateService.convertDate(startDate, true)
    }

    return message
  },
}
